import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";

import { AuthModel } from "app/shared";
import { WindowRef } from "tokens";
import { TranslatePipe } from "@ngx-translate/core";
import { IonSpinner } from "@ionic/angular/standalone";

@Component({
	selector: "ic-signout",
	templateUrl: "sign-out.component.html",
	styleUrls: ["sign-out-component.scss"],
	imports: [TranslatePipe, IonSpinner],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignOutComponent implements OnInit {
	private readonly authModel = inject(AuthModel);
	private readonly window = inject(WindowRef);

	ngOnInit() {
		this.authModel.signOut().subscribe({
			complete: () => this.window.location.reload(),
		});
	}
}
